'use client'

import Link from 'next/link'
import EnquiryPopup from './EnquiryPopup'
import { useState } from 'react'



export default function TopPage() {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false)

  return (
  
    <main id="top" className="w-full relative pt-25">
      <div className="relative w-full">
        <video
          src="/top0.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-auto object-contain"
        >
          Your browser does not support the video tag.
        </video>

        {/* 遮罩层 */}
        <div className="absolute inset-0 bg-black/55" />

        {/* 文字内容 */}
        <div className="absolute inset-0 flex flex-col justify-center text-center text-white px-4">
          <h1 className="text-2xl md:text-3xl lg:text-5xl 2xl:text-8xl font-bold mt-8">
            Simoom
          </h1>

          <p className="max-w-2xl mx-auto text-sm md:text-md lg:text-xl 2xl:text-2xl leading-relaxed mt-4">
            Explore our shop fitouts and residential builds.
          </p>

          <p className="hidden md:flex max-w-2xl mx-auto text-base sm:text-sm md:text-md lg:text-xl 2xl:text-2xl leading-relaxed">
            Each project blends functionality with modern design, crafted to perfection.
          </p>

          {/* 按钮区域 */}
          <div className="mt-10 flex flex-wrap justify-center gap-6">
            {/* Explore 按钮 
            <Link
              href="/projects"
              className="hidden md:flex px-6 py-3 bg-black rounded-full border border-white font-semibold hover:bg-white  hover:text-black transition"
            >
              Explore
            </Link>*/}

            {/* Desktop Enquire now 按钮 */}
            <button
              className="hidden md:inline-block px-6 py-3 bg-white text-black rounded-full font-semibold hover:bg-gradient-to-r hover:text-white hover:from-indigo-600 hover:to-purple-600 cursor-pointer transition"
              onClick={() => setIsEnquiryOpen(true)}
            >
              Enquire now
            </button>
          </div>
        </div>
      </div>

      {/* 弹窗 */}
      <EnquiryPopup isOpen={isEnquiryOpen} setIsOpen={setIsEnquiryOpen} />
    </main>
  )
}



        
